import { render, staticRenderFns } from "./AppointmentBox.vue?vue&type=template&id=5f76d79b&scoped=true"
import script from "./AppointmentBox.vue?vue&type=script&lang=js"
export * from "./AppointmentBox.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBox.vue?vue&type=style&index=0&id=5f76d79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f76d79b",
  null
  
)

export default component.exports